import Vue from 'vue'
import Router from 'vue-router'
import MenusList from './views/MenusList.vue'
import MenusDetail from './views/MenusDetail.vue'
import GruppiList from './views/GruppiList.vue'
import GruppiDetail from './views/GruppiDetail.vue'
import Login from './views/Login.vue'
import PermessiList from './views/PermessiList.vue'
import Benvenuto from './views/Benvenuto.vue'
import PermessiDetail from './views/PermessiDetail.vue'
import UtentiList from './views/UtentiList.vue'
import UtentiDetail from './views/UtentiDetail.vue'
import Tracking from './views/TrackingList.vue'
import TrackingDetail from './views/TrackingDetail.vue'
import IconeList from './views/IconeList.vue'
import IconeDetail from './views/IconeDetail.vue'
import RubricaList from './views/RubricaList.vue'
import RubricaDetail from './views/RubricaDetail.vue'
import Errore from './views/Errore.vue'
import CambiaPassword from './views/CambiaPassword.vue'
import CambiaPasswordOk from './views/CambiaPasswordOk.vue'
import RecuperaPassword from './views/RecuperaPassword.vue'
import TrackList from './views/TrackList.vue'
import TrackDetail from './views/TrackDetail.vue'
import StatiCorrispondentiList from './views/StatiCorrispondentiList.vue'
import StatiCorrispondentiDetail from './views/StatiCorrispondentiDetail.vue'
import StatiSpedizioneList from './views/StatiSpedizioneList.vue'
import StatiSpedizioneDetail from './views/StatiSpedizioneDetail.vue'
import SediList from './views/SediList.vue'
import SediDetail from './views/SediDetail.vue'
import TrackDetailNoUser from './views/TrackDetailNoUser.vue'
import store from './store.js'
import Ritiro from './views/Ritiro.vue'
import RitiroAggiunto from './views/RitiroAggiunto.vue'
import BollettazioneList from './views/BollettazioneList.vue'
import BollettazioneDetail from './views/BollettazioneDetail.vue'
import DisposizioniList from './views/DisposizioniList.vue'
import DisposizioniDetail from './views/DisposizioniDetail.vue'
import TipoIncassoList from './views/TipoIncassoList.vue'
import TipoIncassoDetail from './views/TipoIncassoDetail.vue'
import BollettazioneRiepilogo from './views/BollettazioneRiepilogo.vue'
import PesiVolumiList from './views/PesiVolumiList.vue'
import PesiVolumiDetail from './views/PesiVolumiDetail.vue'
import TraduzioniDetail from './views/TraduzioniDetail.vue'
import TraduzioniList from './views/TraduzioniList.vue'
import TracciatiImportList  from './views/TracciatiImportList.vue'
import ResetPassword from './views/ResetPassword.vue'
import RitiroNew from './views/RitiroNew.vue'
import DownloadPOD from './views/DownloadPOD.vue'
import TrackDetailAs400 from './views/TrackDetailAs400.vue'
import Login_Registrazione from './views/Login_Registrazione.vue'
import Registrazione from './views/Registrazione.vue'
import Registrazione2 from './views/Registrazione2.vue'
import AttivazioneUtente from './views/AttivazioneUtente.vue'
import RegistrazioneBreve from './views/RegistrazioneBreve.vue'
import DisattivazioneUtente from './views/DisattivazioneUtente.vue'
import TrackingListNew from './views/TrackingListNew.vue'
import Landing from './views/Landing.vue'
import Download from './views/Download.vue'
import TrackingRitiriList from './views/TrackingRitiriList.vue'
import TrackingRitiriDetail from './views/TrackingRitiriDetail.vue'
import ProblemaTecnico from './views/ProblemaTecnico.vue'
import NuoviRitiri from './views/NuoviRitiri.vue'
import DownloadRimessi from './views/DownloadRimessi.vue'
import NuovoRitiroAggiunto from './views/NuovoRitiroAggiunto.vue'
import VerificaAttivazione from './views/VerificaAttivazione.vue'
import NuoviRitiriServizi from './views/NuoviRitiriServizi.vue'
import NuovaRubricaList from './views/NuovaRubricaList.vue'
import NuovaRubricaDetail from './views/NuovaRubricaDetail.vue'
import SvincoloGiacenza from './views/SvincoloGiacenza.vue'
import PodAs400 from './views/PodAs400.vue'
import FirmaAs400 from './views/FirmaAs400.vue'
import AnomaliaAs400 from './views/AnomaliaAs400.vue'

Vue.use(Router)

let router = new Router({

  routes: [

    {
      path: '/',
      name: 'Login_Registrazione',
      component: Login_Registrazione
    },
    {
      path: '/AnomaliaAs400/:numeroSpedizione/:numeroLista',
      name: 'AnomaliaAs400',
      component: AnomaliaAs400
    },
    {
      path: '/FirmaAs400/:numeroSpedizione',
      name: 'FirmaAs400',
      component: FirmaAs400
    },
    {
      path: '/PodAs400/:numeroSpedizione',
      name: 'PodAs400',
      component: PodAs400
    },
    {
      path: '/SvincoloGiacenza/:parametro',
      name: 'SvincoloGiacenza',
      component: SvincoloGiacenza
    },
    {
      path: '/NuoviRitiriServizi',
      name: 'NuoviRitiriServizi',
      component: NuoviRitiriServizi
    },
    {
      path: '/VerificaAttivazione',
      name: 'VerificaAttivazione',
      component: VerificaAttivazione
    },
    {
      path: '/ProblemaTecnico',
      name: 'ProblemaTecnico',
      component: ProblemaTecnico
    },
    {
      path: '/NuoviRitiri',
      name: 'NuoviRitiri',
      component: NuoviRitiri
    },
    {
      path: '/DownloadRimessi',
      name: 'DownloadRimessi',
      component: DownloadRimessi
    },
    {
      path: '/Download',
      name: 'Download',
      component: Download
    },
    {
      path: '/landing/:mailInvio/:codice/:idUtente/:idGruppo',
      name: 'Landing',
      component: Landing
    },
    {
      path: '/TrackingNew',
      name: 'Tracking',
      component: Tracking
    },
    {
      path: '/AttivazioneUtente/:id/:hash',
      name: 'AttivazioneUtente',
      component: AttivazioneUtente
    },
    {
      path: '/DisattivazioneUtente/:id/:hash',
      name: 'DisattivazioneUtente',
      component: DisattivazioneUtente
    },
    {
      path: '/RegistrazioneBreve/:codCliente/:email',
      name: 'RegistrazioneBreve',
      component: RegistrazioneBreve
    },
    {
      path: '/LoginRegistrazione',
      name: 'Login_Registrazione',
      component: Login_Registrazione
    },
    {
      path: '/registrazione',
      name: 'Registrazione',
      component: Registrazione
    },
    {
      path: '/registrazione2/:codCliente/:email/:idUtente/:idGruppo',
      name: 'Registrazione2',
      component: Registrazione2
    },
    {
      path: '/menus',
      name: 'MenusList',
      component: MenusList
    },
    {
      path: '/menus/:id',
      name: 'MenusDetail',
      component: MenusDetail
    },
    {
      path: '/gruppi/:id',
      name: 'GruppiDetail',
      component: GruppiDetail
    },
    {
      path: '/gruppi',
      name: 'GruppiList',
      component: GruppiList
    },
    {
      path: '/permessi',
      name: 'PermessiList',
      component: PermessiList
    },
    {
      path: '/permessi/:id/:tipo',
      name: 'PermessiDetail',
      component: PermessiDetail
    },
    {
      path: '/benvenuto',
      name: 'Benvenuto',
      component: Benvenuto
    },
    {
      path: '/utenti',
      name: 'UtentiList',
      component: UtentiList
    },
    {
      path: '/utenti/:id',
      name: 'UtentiDetail',
      component: UtentiDetail
    },
    {
      path: '/tracking',
      name: 'TrackingListNew',
      component: TrackingListNew
    },
    {
      path: '/tracking/:Nservizio',
      name: 'TrackingDetail',
      component: TrackingDetail
    },
    {
      path: '/downloadpod',
      name: 'DownloadPOD',
      component: DownloadPOD
    },
    {
      path: '/icone',
      name: 'IconeList',
      component: IconeList
    },
    {
      path: '/icone/:id',
      name: 'IconeDetail',
      component: IconeDetail
    },
    {
      path: '/rubrica',
      name: 'RubricaList',
      component: RubricaList
    },
    {
      path: '/rubrica/:id/:codiceAzienda',
      name: 'RubricaDetail',
      component: RubricaDetail
    },
    {
      path: '/NuovaRubrica',
      name: 'NuovaRubricaList',
      component: NuovaRubricaList
    },
    {
      path: '/NuovaRubrica/:id/:codiceAzienda',
      name: 'NuovaRubricaDetail',
      component: NuovaRubricaDetail
    },
    {
      path: '/errore',
      name: 'Errore',
      component: Errore
    }, {
      path: '/cambiapassword',
      name: 'CambiaPassword',
      component: CambiaPassword
    },
    {
      path: '/cambiapasswordok',
      name: 'CambiaPasswordOk',
      component: CambiaPasswordOk
    }, {
      path: '/recuperapassword',
      name: 'RecuperaPassword',
      component: RecuperaPassword
    }, {
      path: '/track/:codice/:sha',
      name: 'TrackList',
      component: TrackList
    },{
      path: '/track/:codice/:sha/:Nservizio',
      name: 'TrackDetail',
      component: TrackDetail
    },{
      path: '/staticorrispondenti',
      name: 'StatiCorrispondentiList',
      component: StatiCorrispondentiList
    },
    {
      path: '/staticorrispondenti/:codiceCorris/:statusCorris',
      name: 'StatiCorrispondentiDetail',
      component: StatiCorrispondentiDetail
    },
    {
      path: '/statispedizione',
      name: 'StatiSpedizioneList',
      component: StatiSpedizioneList
    },{
      path: '/statispedizione/:id',
      name: 'StatiSpedizioneDetail',
      component: StatiSpedizioneDetail
    },
    {
      path: '/sedi',
      name: 'SediList',
      component: SediList
    },
    {
      path: '/sedi/:codice',
      name: 'SediDetail',
      component: SediDetail
    },
    {
      path: '/trackingDetail/:Nservizio',
      name: 'TrackDetailNoUser',
      component: TrackDetailNoUser
    },
    {
      path: '/trackingDetails/:Nservizio/:Nddt/:data',
      name: 'TrackDetailAs400',
      component: TrackDetailAs400
    },
    {
      path: '/Ritiro',
      name: 'Ritiro',
      component: Ritiro
    },
    {
      path: '/ritironew',
      name: 'RitiroNew',
      component: RitiroNew
    },
    {
      path: '/RitiroAggiunto/:id',
      name: 'RitiroAggiunto',
      component: RitiroAggiunto
    },
    {
      path: '/NuovoRitiroAggiunto/:id',
      name: 'NuovoRitiroAggiunto',
      component: NuovoRitiroAggiunto
    },
    {
      path: '/Bollettazione',
      name: 'BollettazioneList',
      component: BollettazioneList
    },
    {
      path: '/Bollettazione/:codiceSpedizione/:stato',
      name: 'BollettazioneDetail',
      component: BollettazioneDetail
    },
    {
      path: '/Disposizioni',
      name: 'DisposizioniList',
      component: DisposizioniList
    },
    {
      path: '/Disposizioni/:id',
      name: 'DisposizioniDetail',
      component: DisposizioniDetail
    },
    {
      path: '/Incasso',
      name: 'TipoIncassoList',
      component: TipoIncassoList
    },
    {
      path: '/Incasso/:id',
      name: 'TipoIncassoDetail',
      component: TipoIncassoDetail
    },
    {
      path: '/Bollettazione/Riepilogo/:codiceSpedizione',
      name: 'BollettazioneRiepilogo',
      component: BollettazioneRiepilogo
    },
    {
      path: '/PesiVolumi',
      name: 'PesiVolumiList',
      component: PesiVolumiList
    },
    {
      path: '/PesiVolumi/:Nservizio',
      name: 'PesiVolumiDetail',
      component: PesiVolumiDetail
    },
    {
      path: '/Traduzioni',
      name: 'TraduzioniList',
      component: TraduzioniList
    },
    {
      path: '/Traduzioni/:codice/:lingua',
      name: 'TraduzioniDetail',
      component: TraduzioniDetail
    },
    {
      path: '/Tracciati',
      name: 'TracciatiImportList',
      component: TracciatiImportList
    },
    {
      path: '/Reset/:id/:p',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/trackingritirilist',
      name: 'TrackingRitiriList',
      component: TrackingRitiriList
    },
    {
      path: '/trackingritiridetail/:numrit',
      name: 'TrackingRitiriDetail',
      component: TrackingRitiriDetail
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

export default router